import * as serialize from "../../components/utils/serialize"

export function init() {
    const formUnions = document.getElementById("form-unions")
    const formUnionsSearch = document.getElementById("form-unions-buscar")
    const formUnionsCourses = document.getElementById("form-cursos")

    if (formUnions) {
        const buttonSubmit = formUnions.querySelector("button")

        formUnions.addEventListener("submit", function (e) {
            e.preventDefault();

            if (formUnions.querySelectorAll(".error").length) {
                return false
            }

            if (document.querySelector("#container-sindicate")) {
                document.querySelector("#container-sindicate").innerHTML = ""
                document.querySelector(".loader-sindicate").classList.remove("hidden")
            }

            const data = serialize.serialize(formUnions)
            buttonSubmit.disabled = true;
            buttonSubmit.innerHTML = "Redirecionando...";

            location.href = '/faeg/sindicatos/?' + data;
        })
    }

    if (formUnionsSearch) {
        formUnionsSearch.addEventListener("submit", function () {
            if (document.querySelector("#result-all-search")) {
                document.querySelector("#result-all-search").innerHTML = ""
                document.querySelector(".loader-search").classList.remove("hidden")
            }
        })
    }

    if (formUnionsCourses) {
        formUnionsCourses.addEventListener("submit", function () {
            document.querySelector("#result-formation").innerHTML = ""
            document.querySelector("#result-promotion").innerHTML = ""
            document.querySelector(".course-and-trainings").querySelectorAll(".loader").forEach(function (el) {
                el.classList.remove("hidden")
            })
        })
    }
}

init()
